import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { BalanceDTOBase } from "./BalanceDTOBase";
import type { BalanceTransactionStaff } from "./BalanceTransactionStaff";
import type { BalanceType } from "./BalanceType";
import type { PersonBalanceStaff } from "./PersonBalanceStaff";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class BalanceStaff implements BalanceDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly balanceType: BalanceType, public readonly balanceExpirationDate: Date | null, public readonly balanceMinimumCents: number | null, public readonly balanceAccountNumber: string, public readonly balanceName: string | null, public readonly balanceIsPrivate: boolean | null, public readonly currentAmountCents: number | null, public readonly spendableAmountCents: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly balanceOwner: PersonStaff | null, public readonly personBalances: Array<PersonBalanceStaff> | null, public readonly transactions: Array<BalanceTransactionStaff> | null) {
    this.cbiServiceContext = null;
    this.balanceOwnerLoaded = this.balanceOwner != null;
    this.balanceOwnerCached = this.balanceOwner;
    this.personBalancesLoaded = this.personBalances != null;
    this.personBalancesCached = this.personBalances;
    this.transactionsLoaded = this.transactions != null;
    this.transactionsCached = this.transactions;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private balanceOwnerLoaded: boolean;
  private balanceOwnerCached: PersonStaff | null;
  private personBalancesLoaded: boolean;
  private personBalancesCached: Array<PersonBalanceStaff> | null;
  private transactionsLoaded: boolean;
  private transactionsCached: Array<BalanceTransactionStaff> | null;
  async balanceOwnerLazy(): Promise<PersonStaff | null> {
    if (!this.balanceOwnerLoaded) {
      this.balanceOwnerCached = await this.cbiServiceContext!.balanceService().getBalanceStaffBalanceOwner(this.assignId);
      this.balanceOwnerLoaded = true;
    }
    return this.balanceOwnerCached;
  }
  async personBalancesLazy(): Promise<Array<PersonBalanceStaff>> {
    if (!this.personBalancesLoaded) {
      this.personBalancesCached = await this.cbiServiceContext!.balanceService().getBalanceStaffPersonBalances(this.assignId);
      this.personBalancesLoaded = true;
    }
    return this.personBalancesCached!;
  }
  async transactionsLazy(): Promise<Array<BalanceTransactionStaff>> {
    if (!this.transactionsLoaded) {
      this.transactionsCached = await this.cbiServiceContext!.balanceService().getBalanceStaffTransactions(this.assignId);
      this.transactionsLoaded = true;
    }
    return this.transactionsCached!;
  }
}
